export const HIDDEN_SPACE_KEY = '__HIDDEN_SPACE_KEY__';
